import React from 'react';
import { Phone } from 'lucide-react';
import { mockData } from '../data/mock';

const FloatingCallButton = () => {
  return (
    <a
      href={`tel:${mockData.contact.phone.replace(/\s/g, '')}`}
      className="fixed bottom-6 right-6 z-40 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-full p-4 shadow-2xl hover:shadow-blue-500/50 hover:scale-110 transition-all duration-300 group animate-pulse hover:animate-none"
      aria-label="Appeler maintenant"
    >
      <Phone className="w-6 h-6 group-hover:rotate-12 transition-transform duration-300" />
      <span className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full animate-ping" />
      <span className="absolute -top-2 -right-2 w-4 h-4 bg-red-500 rounded-full" />
    </a>
  );
};

export default FloatingCallButton;
